import { render, staticRenderFns } from "./CurrentPlan.vue?vue&type=template&id=1511fd9a&"
import script from "./CurrentPlan.vue?vue&type=script&lang=js&"
export * from "./CurrentPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports